import Barchart from "./Barchart"
import React, { useState, useEffect } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

function Top10AirportsChart({setloading6}){
    const [userData, setUserData] = useState(null);
    const [userOptions, setUserOption] = useState({});


    const [excelDataChart2,setexcelDataChart2] = useState();
    

    useEffect(() => {
      fetch("api/topairports").then((res) =>
        res.json().then((res) => {
          setexcelDataChart2(res.data.top_airports);

         
          const listOfIds = res.data.top_airports.map((airport, i) => {
            return res.data.top_airports[i]["Αεροδρόμιο"];
          });
  
          const listOfValues = res.data.top_airports.map((airport, i) => {
            return res.data.top_airports[i]["Επιβάτες"]/1000000;
          });

          setUserData({
            labels: listOfIds,
            datasets: [{
              label: "",
              data: listOfValues,
              backgroundColor: "#0F8DD6",
              borderColor: "black",
              borderWidth: 0.1,
            }]
          })
      
          setUserOption({
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
              legend : {
               display: false,
              }
            }
          })
          setloading6(false)
        })
      )
      .catch((error) => {
        console.log("Refetching data for Top10 airports!")
      })
    }, [setloading6]);
  


    return(
      userData? 
        <Barchart chartData={userData} chartOptions = {userOptions} excelData ={excelDataChart2}> </Barchart>
      : <ClipLoader size={100} color={'#123abc'} loading={true}/>   
       
       
    )
}




export default Top10AirportsChart;